import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import {
  useNewRirekishoFormatData,
  type NewRirekishoExampleSentence,
  type NewRirekishoExampleSentences
} from '@/composables/format-edit/useNewRirekishoFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewRirekishoReasonCard',
  props: {
    currentCardId: null,
    previewErrors: null,
    exampleSentences: null,
    textareaMinRows: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  previewErrors: Record<string, string>
  exampleSentences?: NewRirekishoExampleSentences
  textareaMinRows: number
};

const reasonLabel =
  '書類審査、合格のカギは志望動機と自己PRの表現力！最新のAIを使って表現力アップ！'



const formatData = useNewRirekishoFormatData()
const exampleVisible = ref(false)

const reasonExamples = computed(() => props.exampleSentences?.reason || [])

function onSelectExample(item: NewRirekishoExampleSentence) {
  formatData.reason = item.description.replace(/<br>/gi, '\n')
}

return { __sfc: true,reasonLabel, props, formatData, exampleVisible, reasonExamples, onSelectExample, NewRirekishoExampleSentenceDialog }
}

})